import { TMenuAction } from '@dss-libs/shared/type/common-types';
import { TApiKeyMenuAction } from '../../types/settings/api-key-card-actions.type';

export const API_KEY_MENU_ACTIONS: TMenuAction<TApiKeyMenuAction>[] = [
  {
    action: 'rotate',
    label: 'SETTINGS.API_SETTINGS.MENU.ROTATE',
    svgIcon: 'restart-square-outline',
  },
  { action: 'edit', label: 'SETTINGS.API_SETTINGS.MENU.EDIT', svgIcon: 'pen-2-outline' },
  {
    action: 'delete',
    label: 'SETTINGS.API_SETTINGS.MENU.DELETE',
    svgIcon: 'trash-bin-trash-outline',
    styleConfig: { iconClass: 'size-4! text-danger!' },
    danger: true,
  },
];
